export const programTermsAndConditionsMapping = {
  'en-us': 'us-hcom',
  'en-gb': 'us-expedia',
  'fr-ca': 'ca-hcom',
  'fr-fr': 'abritel',
  'de-de': 'fewo-direkt',
};
